import { defineStore } from 'pinia'
import type { RouteRecordRaw } from 'vue-router'
import type { SiteConfig } from '/@/stores/interface'
import { USER_INFO } from '/@/stores/constant/cacheKey'

export const useSiteConfig = defineStore('siteConfig', {
    state: (): SiteConfig => {
        return {
            siteName: '',
            recordNumber: '',
            version: '',
            cdnUrl: '',
            apiUrl: '',
            upload: {
                mode: 'local',
            },
            headNav: [],
            initialize: false,
            userInitialize: false,
            user_register_verify: '',
            payment_agreement: '',
            user_login_phone: 0,
            user_login_wechat: 0,
            logo: '',
            new_version: '',
            enterpriseHint: '',
            tenderHint: '',
            dataHint: '',
            bidHint: '',
            logo_short: '',
            logo_long: '',
            bottom_logo: '',
            bottom_images: '',
            customer_service_url: '',
            copyright: '',
            data_url: [],
            nav_url: '',
            bottom_ewm: '',
            hotline: '',
            w_id: '',
            years: 0,
            domain: 0,
            training_data: 0,
            generate: 0,
            imageV1Score: '',
            imageV2Score: '',
            ganntImageScore: '',
            videoV1Score: '',
            videoV2Score: '',
            imageV3Score: '',
            tableV1Score: '',
            tableV2Score: '',
            tableV3Score: '',
            aiImageScore: '',
            twoDocCompareScore: '',
            threeDocCompareScore: '',
            free_word_logo: '',
            pay_activity_logo: '',
            drawing_analysis: '',
            drawing_generate:'',
            drawing_summary_parameters:'',
            data_protocol:'',
        }
    },
    actions: {
        dataFill(state: SiteConfig) {
            console.log(state)
            this.$state = state
        },
        setHeadNav(headNav: RouteRecordRaw[]) {
            this.headNav = headNav
        },
        setInitialize(initialize: boolean) {
            this.initialize = initialize
        },
        setUserInitialize(userInitialize: boolean) {
            this.userInitialize = userInitialize
        },
    },
    //   persist: {
    //     key: 'siteConfig',
    //   },
})
